import Vue from 'vue'
import * as types from './mutation-types'

export const mutations = {
  [types.SET_BAR_PROGRESS](state, value) {
    Vue.set(state, 'barProgress', value)
  },
  [types.REQUEST_ERROR](state, value) {
    console.log(value)
    Vue.set(state, 'requestError', value)
  },
  [types.UPDATE_FIELD](state, { form, key, value }) {
    Vue.set(state[form], key, value)
  },
  [types.SUBMITTED](state) {
    Vue.set(state, 'submitted', true)
  },
  [types.CALCULATE_OVERALL](state) {

    let overall = 0
    let sum = 0
    const results = ['td_score_understanding', 'td_score_people', 'td_score_process', 'td_score_customer_experience', 'td_score_strategy']
    for (let i = 0; i < results.length; i += 1) {
      sum += state.results[results[i]]
    }
    overall = Math.ceil(sum / results.length)
    console.log(state)
    Vue.set(state.results, 'td_score_overall', overall)
  },
  [types.TEST_CALCULATE_OVERALL](state) {
    let overall = 0
    let sum = 0
    const results = ['cultura_e_lideranca', 'experiencia_do_cliente', 'empreendedorismo_digital', 'tecnologia_digital', 'agilidade_operacional']
    for (let i = 0; i < results.length; i += 1) {
      sum += state.test_results[results[i]]
    }
    overall = Math.floor(sum / results.length)
    Vue.set(state.test_results, 'overall', overall)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js